import { apiFetch } from './client';

export interface UserProfile {
  email:    string;
  fullName: string;
  phone:    string;
  isoCode:  string;
  verified: string;
}

export interface UpdateProfilePayload {
  fullName?: string;
  phone?:    string;
  isoCode?:  string;
}

export async function getProfile(token: string): Promise<UserProfile> {
  const res = await apiFetch<UserProfile>('GET', '/profile', undefined, token);
  if (!res.ok) {
    throw new Error((res.data as any)?.message || 'Failed to load profile');
  }
  return res.data;
}

export async function updateProfile(token: string, payload: UpdateProfilePayload): Promise<void> {
  const res = await apiFetch('PUT', '/profile', payload, token);
  if (!res.ok) {
    const message = (res.data as any)?.message || (res.data as any)?.error || 'Failed to update profile';
    throw new Error(message);
  }
}

export async function changePassword(
  token: string,
  currentPassword: string,
  newPassword: string
): Promise<void> {
  const res = await apiFetch('PUT', '/profile/password', { currentPassword, newPassword }, token);
  if (!res.ok) {
    const message = (res.data as any)?.message || (res.data as any)?.error || 'Failed to change password';
    throw new Error(message);
  }
}
